import { setLoading, setGlobalMessage } from 'eebac/reducers/app';
import { ALERT_SEVERITY, ERROR_MESSAGES } from 'eebac/constants';
import ApiDataHelper from 'eebac/utils/apiDataHelper';
import AddUserFields from 'eebac/constants/fields/compnay/user/add_user';
import { Catch } from 'eebac/reducers/api_exception';
import { loadUsers, setAddNewUser } from './users';

const BASE_PATH = 'COMPANY_ADD_USER_PROFILE_INFO';

export const addUser = () =>
    (dispatch, getState, client) => {

        let state = getState();

        dispatch(setLoading(true));
        let userState = state.COMPANY_ADD_USER;
        let apiData = ApiDataHelper.get(userState,
            AddUserFields);
        if (userState.isEditMode) {
            apiData.id = userState.id;
        }

        (userState.isEditMode ? client.put("/company/user/update", apiData) :
            client.post("/company/user/add", apiData))
            .then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage));
                    dispatch(clearProfileInfoData());
                    dispatch(setAddNewUser(false));
                    dispatch(loadUsers(null, 0));
                } else {
                    if (result.fieldErrors &&
                        Array.isArray(result.fieldErrors)) {
                        dispatch(setProfileInfoData(result.fieldErrors));
                    }

                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const SET_PROFILE_INFO_DATA = `${BASE_PATH}/SET_PROFILE_INFO_DATA`;
export const SET_EDIT_USER_DATA = `${BASE_PATH}/SET_EDIT_USER_DATA`;
export const VALIDATE_PROFILE_INFO_DATA = `${BASE_PATH}/VALIDATE_PROFILE_INFO_DATA`;
export const CLEAR_INFO_DATA = `${BASE_PATH}/CLEAR_INFO_DATA`;
export const PROFILE_FORM_SUBMIT = `${BASE_PATH}/PROFILE_FORM_SUBMIT`;

export const setProfileFormSubmit = (isSubmit) => ({
    type: PROFILE_FORM_SUBMIT,
    isSubmit
});

export const setProfileInfoData = data => ({
    type: SET_PROFILE_INFO_DATA,
    data
});

export const setEditUserData = data => ({
    type: SET_EDIT_USER_DATA,
    data
});

export const validateProfileInfoData = () => ({
    type: VALIDATE_PROFILE_INFO_DATA,
});

export const clearProfileInfoData = () => ({
    type: CLEAR_INFO_DATA,
});

const initialState = {
    id: "",
    firstName: "",
    lastName: "",
    email: '',
    mobileNumber: '',
    password: '',
    userType: '',
    designation: '',

    firstNameError: '',
    lastNameError: '',
    passwordError: '',
    designationError: '',
    emailError: '',
    mobileNumberError: '',
    userTypeError: '',

    validate: false,
    isValid: false,
    isSubmit: false,
    isEditMode: false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_PROFILE_INFO_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case SET_EDIT_USER_DATA:
            return {
                ...state,
                ...action.data
            }
        case VALIDATE_PROFILE_INFO_DATA:
            return { ...state, validate: true }

        case CLEAR_INFO_DATA:
            return { ...initialState }

        case PROFILE_FORM_SUBMIT:
            return { ...state, isSubmit: action.isSubmit, validate: true };
    }

    return state;
}